import { render, staticRenderFns } from "./infopanel.vue?vue&type=template&id=fe99bcb2&scoped=true&"
import script from "./infopanel.vue?vue&type=script&lang=js&"
export * from "./infopanel.vue?vue&type=script&lang=js&"
import style0 from "./infopanel.vue?vue&type=style&index=0&id=fe99bcb2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe99bcb2",
  null
  
)

export default component.exports